// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 780 ? "c37d3baf" : chunkId) + "." + {"197":"6b5bd780adc28e4b","384":"ee761948ac92675f","393":"55472578635fba24","665":"5a5cde192a120189","780":"d018e177a12a2144","803":"e013996ea683e0f1","930":"9bd93e497546bf51"}[chunkId] + ".js";
};